export default __webpack_public_path__ + "static/media/con_chassis03.29ffab1c.jpg";